import { useDndMonitor, useDraggable } from "@dnd-kit/core";
import { Aufbau } from "../../arrangement/Aufbau";
import * as Commons from "oc-commons/Commons";
import { v2, v3 } from "oc-threejs/short3";
import React from "react";
import { teilStyle } from "../../arrangement/grundrissFunctions";
import { triggerChange } from "./GrundrissPage";
import { CoordinateSystem } from "./CoordinateSystem";
import { MAufbauten } from "../../../metamodell";

export function dndEventPosition(cs: CoordinateSystem, event: any) {
  const aev = event.activatorEvent;
  if (aev == null) {
    return v2();
  }
  if (aev.pageX == null) {
    const srcElementRect = aev.srcElement.getBoundingClientRect();
    aev.pageX = srcElementRect.left + srcElementRect.width / 2;
    aev.pageY = srcElementRect.top + srcElementRect.height / 2;
  }
  const screenPos = v2(aev.pageX + event.delta.x, aev.pageY + event.delta.y);
  const pageRect = document.querySelector(".stage2d").getBoundingClientRect();
  screenPos.sub(v2(pageRect.left, pageRect.top));
  const position = cs.pointToGrundriss(screenPos);
  return position;
}

export function AufbauMenuTeil({
  cs,
  aufbauMeta,
  setSelected,
}: {
  cs: CoordinateSystem;
  aufbauMeta: MAufbauten;
  setSelected: (obj: any) => void;
}) {
  const { Key, Label, Size3d, fixedSize } = aufbauMeta;
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: Key,
    data: aufbauMeta,
  });
  const addAufbau = (position) => {
    const newAufbau = new Aufbau(APP.arrangement, {
      Key: Commons.createUniqueIdString(),
      aufbauMeta,
      position: position.clone(),
      size: Size3d.clone(),
      drehung: 0,
      fixedSize: fixedSize,
    });
    APP.arrangement.aufbauten.push(newAufbau);
    triggerChange();
    APP.dirty();
    setSelected(newAufbau);
    APP.logUserAction({ action: "addAufbau", Key });
  };
  useDndMonitor({
    onDragEnd(event) {
      if (Key == event.active.id) {
        const position = dndEventPosition(cs, event);
        addAufbau(position);
      }
    },
  });
  return (
    <button
      ref={setNodeRef}
      id={Key}
      className="aufbau"
      data-button-key={Label}
      {...listeners}
      {...attributes}
      style={{
        ...teilStyle(aufbauMeta),
      }}
      onClick={() => addAufbau(v3())}
      aria-label={I18N("aria::Aufbau hinzufügen:") + Label}
      title={I18N("aria::Aufbau hinzufügen:") + Label}
    >
      {Label}
    </button>
  );
}
